import { render } from "./CustomerTestimonials.vue?vue&type=template&id=e72c17c0&scoped=true"
import script from "./CustomerTestimonials.vue?vue&type=script&lang=js"
export * from "./CustomerTestimonials.vue?vue&type=script&lang=js"

import "./CustomerTestimonials.vue?vue&type=style&index=0&id=e72c17c0&scoped=true&lang=css"
import "./CustomerTestimonials.vue?vue&type=style&index=1&id=e72c17c0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e72c17c0"]])

export default __exports__